import {
  Card as HeroUiCard,
  CardBody as HeroUiCardBody,
  CardFooter as HeroUiCardFooter,
} from '@heroui/card';

export const Card = HeroUiCard;
export const CardBody = HeroUiCardBody;
export const CardFooter = HeroUiCardFooter;
